<template>
  <div class="animated fadeIn" id="actualites">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2" /><strong>Liste des actualités</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="items" :options="options">
          <div v-if="canAccess(rules.MANAGE_NEWS_FRONT)"  slot="action" slot-scope="props" class="slot-actions">
            <b-button type="button" @click.prevent="destroy(props.row.id)" class="badge badge-danger p-2"><i class="fa fa-remove"></i> Supprimer
            </b-button>
            <b-button type="button" @click="addNews('edit', props.row.id)" class="badge badge-primary p-2">
              <i class="fa fa-edit"></i> Modifier
            </b-button>
          </div>
          <div slot="surtitre" slot-scope="props" class="slot-surtitre">{{ props.row.surtitre }}</div>
          <div slot="titre" slot-scope="props" class="slot-titre">{{ props.row.titre }}</div>
          <div slot="type_rente" slot-scope="props" class="slot-rente">{{ props.row.type_rente }}</div>

          <div v-if="props.row.date_debut" slot="date_debut" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.date_debut) }}</span>
          </div>
          <div v-if="props.row.date_fin" slot="date_fin" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.date_fin) }}</span>
          </div>
          
        </v-client-table>
      </b-card-body>
      <div slot="footer" v-if="canAccess(rules.MANAGE_NEWS_FRONT)">
        <b-button type="button"  @click="addNews('add')" class="pull-right" size="md" variant="primary">
            <i class="fa fa-plus"></i> Ajouter une actualité
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'
import {espaceBeneficiaireRules, hasRule} from '../../utils/rulesHelper'

export default {
  data() {
    return {
      rules: espaceBeneficiaireRules,
      columns: [
        "surtitre",
        "titre",
        "texte",
        "type_rente",
        "date_debut",
        "date_fin",
        "action"
      ],
      items: [],
      options: {
        headings: {
          surtitre: "Surtitre",
          titre: "Titre",
          texte: "Contenu",
          type_rente: "Type de rente",
          date_debut: "Date début",
          date_fin: "Date fin",
          action: "Action"
        },
        sortable: ["surtitre", "titre"],
        filterable: false,
        perPage: 10,
        perPageValues: [10, 25, 50],
        texts: {
          filterPlaceholder: "Surtitre, Titre"
        },
        orderBy: { column: "surtitre " }
      }
    };
  },
  mounted() {
    this.all();
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] =
      getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    canAccess(rule) {
      return hasRule(rule)
    },
    urlUpdated(url) {
      this.documentError = undefined;
      this.url = url;
    },
    onDocumentErrored(e) {
      this.documentError = e.text;
    },
    all() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/espaceBeneficiaire/news")
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          this.items = response.data.news;
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    destroy(id) {
      this.$swal.fire({
        title: 'Êtes-vous sûr?',
        text: "Voulez-vous vraiment supprimer cette actualité ?",
        type: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonColor:"#ff1744",
        confirmButtonText: 'Annuler',
        cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (!result.value) {
            this.$store.commit('IS_LOADING', true)
            this.$axios
            .post("/espaceBeneficiaire/news/delete/"+id)
            .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'L\'actualité a bien été supprimée',showConfirmButton: false, timer: 5000})
                  this.all()
            })
            .catch(function(error){
              self.$store.commit('IS_LOADING', false)
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Un problème est survenu, merci de contacter l\'administrateur',showConfirmButton: false, timer: 5000})
            })
          }
        })

    },
    addNews(to,id) {
      if (to === 'edit') {
          this.$router.push({ path: '/espace-beneficiaire/actualites/edit/' + id })
      } else if(to === "add") {
          this.$router.push({ path: '/espace-beneficiaire/actualites/add' })
      }
    },
    formatDate(textDate) {
      let date = (textDate !== null) ? new Date(textDate).toLocaleDateString('fr-FR') : "-";
      return date;
    }
  }
};
</script>
